import { useEffect, useState } from 'react';

import { useListingsDesktopTwoRails } from '@/components/_shared/contexts/ExperimentsContext';

export type TwoRailsExperimentStatus = 'active' | 'inactive';

export const useTwoRailsExperimentStatus = (): TwoRailsExperimentStatus => {
  const isListingsDesktopTwoRails = useListingsDesktopTwoRails();
  const [clientExperimentState, setClientExperimentState] = useState(false);

  useEffect(() => {
    setClientExperimentState(isListingsDesktopTwoRails);
  }, [isListingsDesktopTwoRails]);

  return clientExperimentState ? 'active' : 'inactive';
};
